import { render, staticRenderFns } from "./editToken.vue?vue&type=template&id=1b8dc311&"
import script from "./editToken.vue?vue&type=script&lang=js&"
export * from "./editToken.vue?vue&type=script&lang=js&"
import style0 from "./editToken.vue?vue&type=style&index=0&id=1b8dc311&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports